import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";

function initPublicSignContractView() {
	const confirmContractButton = document.querySelector('.confirm-contract-button');

	confirmContractButton.addEventListener('click', confirmContract);

	/**
	 * @type {HTMLInputElement}
	 */
	const confirmCheckbox = document.querySelector('#confirm-contract-checkbox');

	confirmCheckbox.addEventListener('change', handleCheckboxToggle);

	// Initial render
	handleCheckboxToggle();

	/** Methods */
	function handleCheckboxToggle() {
		if (confirmCheckbox.checked) {
			confirmContractButton.disabled = false;
			confirmContractButton.title = '';
		} else {
			confirmContractButton.disabled = true;
			confirmContractButton.title = 'You must read and agree to the contract to continue';
		}
	}

	function confirmContract() {
		if (confirmCheckbox.checked === false) {
			return;
		}

		const confirmRoute = document.querySelector('input[name="confirm_route"]').value;

		loading();

		Axios.post(confirmRoute)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initPublicSignContractView}
